import { cva } from 'cva'

export const typographyVariants = cva({
  variants: {
    size: {
      display: ['text-3xl'],
      subtitle: ['text-subtitle'],
      h1: ['text-2xl'],
      h2: ['text-xl'],
      h3: ['text-xl', 'font-semibold'],
      h4: ['text-xl', 'font-normal'],
      h5: ['text-lg', 'font-bold'],
      h6: ['text-md'],
      body: ['text-body'],
      'body-regular': ['text-body-regular'],
      badge: ['text-badge'],
      body1: ['text-lg', 'font-normal'],
      body2: ['text-xs', 'font-medium'],
      caption: ['text-xs'],
    },
    weight: {
      thin: ['font-thin'],
      extralight: ['font-extralight'],
      light: ['font-light'],
      normal: ['font-normal'],
      medium: ['font-medium'],
      semibold: ['font-semibold'],
      bold: ['font-bold'],
      extrabold: ['font-extrabold'],
    },
  },

  defaultVariants: {
    size: 'body1',
  },
})
